// Courses page interactivity

// What You Get Tabs
function initWhatYouGetTabs() {
  const tabs = document.querySelectorAll(".what-you-get__tab")
  const panels = document.querySelectorAll(".what-you-get__panel")

  if (!tabs.length || !panels.length) return

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const targetPanel = tab.dataset.tab

      // Remove active class from all tabs and panels
      tabs.forEach((t) => t.classList.remove("what-you-get__tab--active"))
      panels.forEach((p) => {
        p.classList.remove("what-you-get__panel--active")
        p.style.display = "none"
      })

      // Add active class to clicked tab and corresponding panel
      tab.classList.add("what-you-get__tab--active")
      const activePanel = document.querySelector(`[data-panel="${targetPanel}"]`)
      if (activePanel) {
        activePanel.style.display = "grid"
        setTimeout(() => {
          activePanel.classList.add("what-you-get__panel--active")
        }, 10)
      }
    })
  })
}

// Animate progress bars on scroll
function initProgressAnimation() {
  const progressBars = document.querySelectorAll(".progress-comparison__bar-fill")

  if (!progressBars.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const bar = entry.target
          const targetWidth = bar.dataset.targetWidth
          if (targetWidth) {
            bar.style.width = targetWidth
          }
        }
      })
    },
    { threshold: 0.5 },
  )

  progressBars.forEach((bar) => {
    // Get the computed width or inline style width
    const computedWidth = window.getComputedStyle(bar).width
    const targetWidth = bar.style.width || computedWidth

    // Store target width and reset to 0
    bar.dataset.targetWidth = targetWidth
    bar.style.width = "0%"

    observer.observe(bar)
  })
}

// Initialize all courses page features
export function initCoursesPage() {
  if (document.querySelector(".courses-hero")) {
    initWhatYouGetTabs()
    initProgressAnimation()
    console.log("[v0] Courses page features initialized")
  }
}


// JavaScript для анимации и интерактивности Hero блока
document.addEventListener("DOMContentLoaded", () => {
  const heroImage = document.querySelector(".courses-hero__img")
  const heroWrapper = document.querySelector(".courses-hero__image-wrapper")

  if (heroImage && heroWrapper) {
    // Дополнительный эффект при наведении мыши (поверх базовой анимации)
    heroWrapper.addEventListener("mousemove", (e) => {
      // Останавливаем базовую анимацию при наведении мыши
      heroImage.style.animation = "none"

      const bounds = heroWrapper.getBoundingClientRect()
      const mouseX = e.clientX - bounds.left
      const mouseY = e.clientY - bounds.top

      const centerX = bounds.width / 2
      const centerY = bounds.height / 2

      const rotateY = (mouseX - centerX) / 15
      const rotateX = (centerY - mouseY) / 15

      heroImage.style.transform = `perspective(1000px) rotateY(${rotateY}deg) rotateX(${rotateX}deg)`
    })

    // Возврат к базовой анимации при уходе мыши
    heroWrapper.addEventListener("mouseleave", () => {
      heroImage.style.animation = "gentle-float 8s ease-in-out infinite"
      heroImage.style.transform = ""
    })
  }

  // Анимация чисел в блоке статистики
  const statsNumbers = document.querySelectorAll(".courses-hero__stat-number")

  if (statsNumbers.length) {
    // Функция проверки видимости элемента
    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect()
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }

    // Функция анимации числа
    function animateNumber(element) {
      const targetValue = Number.parseInt(element.textContent.replace(/[^0-9]/g, ""))
      let currentValue = 0
      const duration = 2000 // 2 секунды
      const stepTime = 20
      const totalSteps = duration / stepTime
      const stepValue = targetValue / totalSteps
      const suffix = element.textContent.includes("+") ? "+" : element.textContent.includes("%") ? "%" : ""

      const interval = setInterval(() => {
        currentValue += stepValue
        if (currentValue >= targetValue) {
          currentValue = targetValue
          clearInterval(interval)
        }
        element.textContent = Math.floor(currentValue) + suffix
      }, stepTime)

      // Отмечаем, что анимация уже запущена
      element.dataset.animated = "true"
    }

    // Функция проверки и запуска анимации
    function checkAndAnimateNumbers() {
      statsNumbers.forEach((number) => {
        if (!number.dataset.animated && isElementInViewport(number)) {
          animateNumber(number)
        }
      })
    }

    // Запускаем проверку сразу при загрузке
    checkAndAnimateNumbers()

    // И при прокрутке страницы
    window.addEventListener("scroll", checkAndAnimateNumbers)
  }

  // Плавная параллакс-анимация для декоративных элементов
  window.addEventListener("scroll", () => {
    const scrollPosition = window.scrollY
    const heroSection = document.querySelector(".courses-hero")

    if (heroSection) {
      const heroHeight = heroSection.offsetHeight
      const scrollPercentage = Math.min(scrollPosition / heroHeight, 1)

      // Параллакс для заголовка и контента
      const content = document.querySelector(".courses-hero__content")
      if (content) {
        content.style.transform = `translateY(${scrollPercentage * 50}px)`
        // content.style.opacity = 1 - scrollPercentage;
      }

      // Параллакс для изображения (движется с другой скоростью)
      const image = document.querySelector(".courses-hero__image")
      if (image) {
        image.style.transform = `translateY(${scrollPercentage * 80}px)`
        // image.style.opacity = 1 - scrollPercentage;
      }
    }
  })
})
